import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export type PageTitleProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function PageTitle({ title, subtitle, actions, className }: PageTitleProps) {
  return (
    <div className={cn("mb-4 flex flex-wrap items-start justify-between gap-3 md:mb-6", className)}>
      <div className="min-w-0">
        <h1 className="font-display text-2xl font-semibold leading-tight tracking-tight md:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-fg-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
